import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import styles from './DownloadSIM.module.less';

import Dialog from '../../components/Dialog/Dialog';
import { downloadShowSIM } from '../../actions/downloadTask';
import { logging, logPostInfo } from '../../actions/log';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectDownload = createSelector(
  state => state.downloadTask,
  downloadTask => downloadTask,
);

export default () => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const { showSIM } = useSelector(selectDownload); // 下载任务

  // 初始化 拿到下载路径
  useEffect(() => {
    dispatch(
      logging({
        category: 'P',
        action: showSIM === `SIM_64` ? 'Dialog_SIM64' : 'Dialog_SIM_RunErr',
        label: '',
        param2: {
          source: showSIM === `SIM_64` ? 'Dialog_SIM64' : 'Dialog_SIM_RunErr',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: '0',
        },
      }),
    );
  }, []);

  // 设置下载路径
  const handleClose = useCallback(flag => {
    dispatch(
      logging({
        category: 'C',
        action: showSIM === `SIM_64` ? 'Dialog_SIM64' : 'Dialog_SIM_RunErr',
        label: '',
        param2: {
          source: showSIM === `SIM_64` ? 'Dialog_SIM64' : 'Dialog_SIM_RunErr',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          flag: flag,
        },
      }),
    );
    dispatch(downloadShowSIM(''));
  }, []);

  return (
    <>
      <Dialog
        title={'温馨提示'}
        maskStyle={styles.file_mask}
        containerStyle={styles.file_mask_container}
        handleClose={() => {
          handleClose(1);
        }}
      >
        <div className={styles.file_content}>
          <div className={styles.file_content_text}>
            {showSIM === `SIM_64` &&
              '当前环境无法安装该应用。请前往联想模拟器，在多开中添加一个64位镜像。'}
            {showSIM === `SIM_Need_Restart` &&
              '检测到当前电脑环境发生变化，模拟器需要重启电脑后才能正常使用。'}
          </div>

          <div className={styles.file_content_opt}>
            <div
              className={styles.file_content_btn}
              onClick={() => {
                handleClose(2);
              }}
            >
              知道了
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};
